export const QA_NAME_GRETA_AI_CHAT_SCROLL_TO_BOTTOM =
  'gretaAIChatScrollToBottom'
